export const getAssociatedIds = (cat) => {
  const associatedIds = { quizIds: [], postIds: [], exerciseIds: [] };

  const _getAssociatedIds = (cat) => {
    if (cat.quizzes) {
      associatedIds.quizIds = [
        ...associatedIds.quizIds,
        ...cat.quizzes.map((quiz) => quiz.id),
      ];
    }
    if (cat.posts) {
      associatedIds.postIds = [
        ...associatedIds.postIds,
        ...cat.posts.map((post) => post.id),
      ];
    }
    if (cat.exercises) {
      associatedIds.exerciseIds = [
        ...associatedIds.exerciseIds,
        ...cat.exercises.map((exercise) => exercise.id),
      ];
    }
  };
  const _getFromCategory = (category) => {
    _getAssociatedIds(category);
    if (!category.children) return;
    category.children.forEach((cat) => {
      if (cat.slug) {
        _getFromCategory(cat);
      }
    });
  };
  _getFromCategory(cat);

  return associatedIds;
};
